// extracted by mini-css-extract-plugin
export default {"CentreSelectorContainer":"centre-selector-device_CentreSelectorContainer__2Lyuw"};